import { SVGProps } from "react";

export const Close = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="m8.001 9.355-6.145 6.144-.035-.029L.5 14.149l.034-.034 6.113-6.114L.5 1.853l.034-.034L1.853.5l6.148 6.147L14.148.5 15.5 1.853l-.034.034-6.114 6.114 6.147 6.147-1.351 1.353Zm-6.148 6.08 6.148-6.147 6.149 6.146 1.283-1.284-1.283 1.284-6.149-6.146-6.148 6.147ZM.564 14.149Zm8.717-6.147 6.148-6.148ZM.564 1.854l6.147 6.148Z" />
    </svg>
  );
};
